import * as R from 'ramda'
import avatarFemale from '../assets/avatar_female.png'
import avatarMale from '../assets/avatar_male.png'

export const getAvatar = user => {
  const gender = R.path(['gender'], user)
  let avatar = avatarMale
  if (gender === 'female') avatar = avatarFemale
  return R.pathOr(avatar, ['profile_picture'], user)
}



// WEBPACK FOOTER //
// /opt/build/repo/src/utils/profile.js